import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 19"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#000",
  d: "M2.001 16.259h1.4l8.63-8.63-1.4-1.4L2 14.857v1.4ZM16.31 6.179l-4.253-4.203 1.401-1.4A1.921 1.921 0 0 1 14.87 0c.559 0 1.03.192 1.414.575l1.4 1.401c.384.384.584.846.6 1.388a1.808 1.808 0 0 1-.55 1.389L16.31 6.178Zm-1.451 1.475L4.252 18.26H0v-4.253L10.606 3.402l4.252 4.252Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };